import { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./styles/Blog.css";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

function Blog() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch(
      "https://stari-vlah-strapi-54837937b4c4.herokuapp.com/api/blogs?populate=*&sort=createdAt:desc"
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => setBlogs(data.data || []))
      .catch((err) => console.error("Error fetching blogs:", err));
}, []);

  return (
    <>
      <Helmet>
        <link
          rel="preload"
          href="/images/blogHeadImage.webp"
          as="image"
          fetchPriority="high"
        />
        <title>Blog - Apartman Stari Vlah Zlatibor | Smestaj Zlatibor</title>
        <meta
          name="description"
          content="Pročitajte korisne savete, vodiče i zanimljivosti o smeštaju, putovanjima i odmoru na Zlatiboru."
        />
        <meta
          name="keywords"
          content="Zlatibor blog, apartmani Zlatibor, smeštaj Zlatibor, putovanje Zlatibor, vodič Zlatibor, odmor Zlatibor, planina Zlatibor, saveti za putovanje, blog o apartmanima"
        />
        <link rel="canonical" href="https://starivlahzlatibor.rs/blog" />
      </Helmet>
      <Header />

      <div className="blogHeadDiv">
        <img
          src="/images/blogHeadImage.webp"
          className="blogHeadImg"
          alt="Apartman Stari Vlah Zlatibor Blog, Smestaj Zlatibor"
        />
        <motion.h2 className="blogHeader" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>Blog</motion.h2>
        <h1 className="blogNameHeader">Apartman Stari Vlah</h1>
        <motion.h3 className="blogDescriptiveHeader" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>
          Otkrijte šta Zlatibor nudi – od netaknute prirode do vrhunske
          gastronomske ponude. Sve što treba da znate pre nego što posetite ovaj
          planinski raj!
        </motion.h3>
      </div>
      <div className="blogListDiv">
        {blogs.length > 0 ? (
          blogs.map((blog) => {
            const {
              Title,
              slug,
              meta_description,
              publishDate,
              coverImage,
              firstTextContent,
            } = blog;

            const imageUrl = coverImage?.url || "/images/default-blog.jpg";

            return (
              <motion.div
                key={blog.id}
                className="blogCard"
                onClick={() => navigate(`/blog/${slug}`)}
                initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.5 }}
              >
                <div className="blogCardImgDiv">
                  <img
                    className="blogCardImg"
                    src={imageUrl}
                    alt={blog.cover_alt || "Apartman Zlatibor Blog Slika"}
                  />
                </div>
                <h3 className="blogCardHeader">{Title}</h3>
                <p className="blogCardParagraph">
                  {firstTextContent?.[0]?.children
                    ?.map((child) => child.text)
                    .join(" ")}
                </p>
                <p className="blogCardDate">
                  {new Date(publishDate).toLocaleDateString()}
                </p>
              </motion.div>
            );
          })
        ) : (
          <p className="noBlogsMessage">Nema dostupnih blogova.</p>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Blog;
